<template>
  <div>
    <!--nav-bar></nav-bar-->
    <div class="login_tit">
       <img src="../../assets/image/xf_vue_index.jpg" hight="100px" width="100px" alt="center">
    </div>
    <section style="padding: 30px 30px; display: flex; flex-flow: column nowrap;">
      <div style="font-size: 20px; font-weight: bold;">重设密码</div>
      <div>请输入新的密码，包含大小字母、数字、特殊字符至少3种且长度8位以上</div>
      <div>
        <van-cell-group>
          <van-field
                  v-model="pwd"
                  center
                  clearable
                  placeholder="请输入密码"
                  style="background-color: WhiteSmoke"
				  v-validate="'required|password'"
                  ref="pwd"
                  type="password"
          >
          </van-field>
          <van-field
                  v-model="checkpwd"
                  center
                  clearable
                  placeholder="请再次输入密码"
                  style="background-color: WhiteSmoke"
                  ref="checkpwd"
                  type="password"
          >
          </van-field>
        </van-cell-group>
        <span style="color: red" v-show="errMsg">{{ errMsg }}</span>
      </div>
      <div style="background-color: DarkGray">
        <van-button :type="type" block :disabled="loginDisabled" @click="login">确认</van-button>
      </div>
    </section>
  </div>
</template>

<script>
  import NavBar from "@/components/NavBar";
  import {modifyPassword} from "@/api";
  import {isCode,IsCard,isPwd} from "@/utils/commons";
  import {auth_data}  from "@/utils/auth";
  import {Toast} from "vant";

  export default {
    name: "RetrievePwd",
    components: {NavBar},
    mounted(){
      //this.$refs.pwd.focus();
    },
    watch: {
     pwd(newVal){
       if(newVal.length > 7){
         this.loginDisabled = false;
         this.type = 'danger'
       } else {
         this.loginDisabled = 'disabled';
         this.type = 'default'
		 this.errMsg = ''
       }
     },
    },
    data(){
      return {
        loginDisabled: 'disabled',
        type: 'default',
        errMsg: '',
        phone: this.$store.state.phone,
        pwd: '',
        checkpwd: '',
        disabled: 'disabled',
        // 发送验证码按钮文字
        text: ''
      }
    },
    methods: {
      blur(){
        // 修改store中phone
        if(IsCard(this.tel)){
          this.$store.commit('updatePhone', this.tel)
        }
      },
      // 完成密码修改并进行登录跳转
      login(){
		if(!isPwd(this.pwd)){
			this.errMsg = '密码需包含大小字母、数字、特殊字符至少3种且长度8位以上';
			return
		}
		//console.log(this.pwd + this.checkpwd)
		if(this.pwd !==  this.checkpwd){
		    this.errMsg = '两次输入密码不一致!';
		    return
		}
		var sign = auth_data(this.phone+this.pwd);
        let params = {
          phone: this.phone,
          password: this.pwd,
		  sign : sign,
        };
        modifyPassword(params)
            .then(res => {
              if(res.code !== 200){
                this.errMsg = res.msg;
              }else{
                this.$router.push('/LoginByPwd');
              }
            })
      },
   
    },
    created(){
      //this.sendCode();
    }
  }
</script>

<style scoped>
.login_tit {
  display: flex;
  justify-content: center;
  align-items: center;
}
.login_tit img{
  width : 100%;
}
  section div {
    margin-bottom: 16px;
  }
</style>
